import React from "react";
import { Editor, EditorProvider } from "react-simple-wysiwyg";

export default function AddtionalPreview({
    additionalInfo = "This is the alcohol that we will drop off. Not necessarily the alcohol that will be charged.This is the alcohol that we will drop off. Not necessarily the alcohol that will be charged.",
    contract
}: { additionalInfo?: string; contract?: any }) {
    return (
        // <div className="min-h-screen bg-gray-100 py-10 print:bg-white print:py-0">
        <div className="min-h-[70vh]">
            {/* Header */}
            <header className="mb-6">
                <h1 className="font-[600] text-[16px] text-[#282828]">Quote</h1>
            </header>

            {/* Additional Information */}
            <section className="mb-4">
                <h2 className="mb-2 font-[600] text-[14px] text-[#282828]">
                    Additional Information
                </h2>
                <p className="text-[10px] leading-6 text-[#8D8D8D] max-h-[300px] overflow-y-auto pr-2 whitespace-pre-wrap break-words">{additionalInfo}</p>
            </section>

            <div className="h-[1px] bg-gray-200 my-4" />

            {/* Contract */}
            <section>
                <h2 className="text-[#282828] font-[600] text-[14px]">
                    Contract
                </h2>

                <div className="mb-4">
                    {contract?.body &&
                        <EditorProvider >
                            <Editor
                                containerProps={{
                                    style: {
                                        border: 'none',
                                        backgroundColor: '#ffffff',
                                        outline: 'none !important',
                                        fontSize: 12,
                                        maxHeight: '520px',
                                        overflowY: 'auto',
                                    }
                                }}
                                value={contract?.body}
                                disabled
                            />
                        </EditorProvider>
                    }
                </div>
            </section>
        </div>
        // </div>
    );
}
